import Tween from "tween.ts";
import Animation from "./Animation";
import Switcher from "../entities/UI/Switcher";


export default class SwitcherAnimation extends Animation {
  constructor(Switcher: Switcher) {
    super();
    const alpha= 0;
    new Tween.Tween({alpha })
      .to({ alpha:1 }, 500)
      .easing(Tween.Easing.Linear.None)
      .onUpdate(({alpha}) => {
        Switcher.setActive(alpha);
      })
      .start()
  }
}